import { render, staticRenderFns } from "./termPersonal.vue?vue&type=template&id=2ede462e&"
import script from "./termPersonal.vue?vue&type=script&lang=js&"
export * from "./termPersonal.vue?vue&type=script&lang=js&"
import style0 from "./termPersonal.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports